import * as Icons from '@zds/icons';

const invalidIconNames = [
  'getFontFaceStyle',
  'getFontFileURI'
];

const iconList = Object.entries(Icons)
  .filter(([name]) => !invalidIconNames.includes(name))
  .filter(([, icon]) =>
    typeof icon !== 'string' && typeof icon?.name === 'string'
  )
  .map(([iconName, component]) => ({
    label: iconName,
    value: iconName,
    component
  }));
;

export default  iconList;
